<template>
    <section>
        <!-- <h2>Dengue</h2> -->
        <div class="text-center">
            <img src="@/assets/img/dengue.jpg" class="img-dengue " alt="">
        </div>
    </section>
</template>
<style scoped>
    .img-dengue{
        width: 100%;
        max-width: 600px;
        height: auto;
    }
</style>